export interface Vector3 {
    readonly x: number;
    readonly y: number;
    readonly z: number;
}

export interface Quaternion {
    readonly x: number;
    readonly y: number;
    readonly z: number;
    readonly w: number;
}

export type Coordinates2D = [number, number];
export type Coordinates3D = [number, number, number];

export type MapData3dObjectType =
    | 'model'
    | 'directional_light'
    | 'hemisphere_light'
    | 'ambient_light'
    | 'point_light'
    | 'spot_light';

export interface MapData3dObjectGeometry {
    readonly type: 'Point';
    readonly coordinates: Coordinates2D | Coordinates3D;
}

export interface MapData3dObjectProperties {
    readonly externalId: string;
    readonly title?: string;
    readonly type: MapData3dObjectType;

    readonly scale?: Vector3;
    readonly quaternion?: Quaternion;
    readonly minZoom?: number;
    readonly maxZoom?: number;
    readonly modelPath?: string;

    readonly color?: string;
    readonly intensity?: number;
}

export interface MapData3dObject {
    readonly type: 'Feature';
    readonly geometry: MapData3dObjectGeometry;
    readonly properties: MapData3dObjectProperties;
}

export interface Map3dObjectRequestGeometry {
    type: 'Point';
    coordinates: Coordinates2D | Coordinates3D;
}

export interface Map3dObjectRequestProperties {
    title?: string;
    type?: MapData3dObjectType;
    scale?: Vector3;
    quaternion?: Quaternion;
    minZoom?: number;
    maxZoom?: number;
    modelPath?: string;
    color?: string;
    intensity?: number;
}

export interface CreateMap3dObjectRequest {
    gameMapExternalId: string;
    geometry: Map3dObjectRequestGeometry;
    properties: Map3dObjectRequestProperties;
}

export interface UpdateMap3dObjectRequest {
    geometry: Map3dObjectRequestGeometry;
    properties: Map3dObjectRequestProperties & {
        type: MapData3dObjectType;
    };
}

export interface Upload3dObjectResponse {
    model_id: number;
}

export enum EditMode {
    Translate = 'translate',
    Rotate = 'rotate',
    Scale = 'scale',
}
